export default __webpack_public_path__ + "static/media/rocket.a50e83af.png";